export default "__VITE_ASSET__CN26Rnsb__"